<template>
  <div>
    <div class="userbanner">
      <div class="usercenter">用户中心</div>
    </div>
    <div class="app-wrap">
      <div class="app-background">
        <div class="panel">
          <div class="panel-left">
            <el-menu
              router
              :default-active="activeMenu"
              unique-opened
              active-text-color="#0385f1"
              text-color="#a2a2a2"
            >
              <div class="role-menu" v-for="item in list" :key="item.index">
                <el-menu-item v-if="!item.child.length" :index="item.path">{{item.name}}</el-menu-item>
                <el-submenu v-else :index="item.index">
                  <template slot="title">
                    <i :class="'iconfont '+item.icon"></i>
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item v-for="(v,i) in item.child" :key="i" :index="v.path">{{ v.name }}</el-menu-item>
                </el-submenu>
              </div>
            </el-menu>
          </div>
          <div class="panel-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          name: "入库申请查询",
          icon: "icon-a-jiluwendang",
          index: "1",
          path:'/usercenter/applyHistory',
          child: [
          ]
        },
        {
          name: "异议记录",
          icon: "icon-a-jiluwendang",
          index: "2",
          path:'/usercenter/objection',
          child: [
          ]
        },
        {
          name: "基础信息管理",
          icon: "icon-peixunpeixunxinxi",
          index: "3",
          child: [
            {
              name: "重点开发项目管理",
              path: "/usercenter/importantprojectManage"
            },
            {
              name: "专利或技术获各级奖励管理",
              path: "/usercenter/prizeManage"
            },
            {
              name: "经济指标数据管理",
              path: "/usercenter/economicManage"
            },
            {
              name: "自主商标品牌建设情况管理",
              path: "/usercenter/brandManage"
            },
            {
              name: "参与专利池运营情况管理",
              path: "/usercenter/patentpoolManage"
            },
            {
              name: "专利转化指标数据管理",
              path: "/usercenter/patenttransManage"
            }
          ]
        }
      ]
    };
  },
  computed: {
    activeMenu() {
    //   const route = this.$route;
    //   const { path } = route;
    //   let paths = "";
    //   this.list.forEach(e => {
    //     e.path.forEach(i => {
    //       if (i.commonPath && path.startsWith(i.commonPath)) {
    //         paths = i.path;
    //         return;
    //       } else if (!i.commonPath && path == i.path) {
    //         paths = i.path;
    //         return;
    //       }
    //     });
    //   });
    //   return paths || path;
    return '1'
    }
  },
  created() {},
  methods: {
    // changeApplyType(index) {
    //   if (this.applyIndex != index) {
    //     this.applyIndex = index;
    //     this.componentId = this.getComponentId(index);
    //   }
    // },
    // getComponentId(index) {
    //   return {
    //     0: "basic",
    //     1: "company",
    //     2: "intellectual",
    //     3: "patent",
    //     4: "requireCollect",
    //   }[index];
    // }
  }
};
</script>
<style scoped lang="less">
.app-wrap {
  width: 100%;
  background-color: #f4f6fa;
}
.app-background {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
}

#banner-wrap {
  width: 100%;
  // max-width: 1200px;
  height: 520px;
  // background-color: blue;

  background-size: 100% 100%;
}
.apply-img {
  width: 100%;
  height: 180px;
  background-color: #a7d0fe;
}
.userbanner {
  width: 100%;
  padding: 30px 0 0;
  background-image: linear-gradient(to bottom,#d2e3fa,#eff2f9);
}
.usercenter {
  height: 118px;
  width: 1200px;
  margin: 0 auto;
  border-radius: 10px;
  background: url("~@/assets/yonghuzhongxin.png");
  background-size: 100% 100%;
  overflow: hidden;
  color: #fff;
  line-height: 118px;
  font-size: 24px;
  font-weight: 700;
  text-indent: 60px;
  letter-spacing: 4px;
}
.applybox {
  display: flex;
  padding: 30px 0;
  justify-content: space-between;
  background-color: #f5f6fa;
  .apply_button {
    border-radius: 24.78px;
    font-size: 18px;
    cursor: pointer;
    padding: 12px 60px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #3f93f6;
  }
  .apply_button.active {
    color: #fff;
    background-color: #3f93f6;
  }
}
.panel {
  display: flex;
  justify-content: space-between;
  height: 740px;
  .panel-left {
    width: 280px;
    height: 100%;
    margin-right: 30px;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px 0 20px 20px;
  }
  .panel-right {
    flex: 1;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
  }
}
/deep/ .el-menu {
  border-right: none;

  .el-submenu {
    .el-menu-item {
      text-indent: 20px;
    }

    .el-menu-item.is-active {
      background: url(~@/assets/submenu-bg.png) 40px 7px no-repeat;
    }
  }
  .el-submenu.is-opened .el-submenu__title {
    background: url(~@/assets/menu-bg.png);
    background-size: 100% 100%;
    i,
    span {
      color: #fff;
    }
  }
  .el-submenu__title i,
  .el-submenu__title span {
    color: #333;
  }
}
.iconfont {
  font-size: 16px;
  margin: 0 8px 0 3px;
}
/deep/ .role-menu>.el-menu-item{
padding-left: 20px;
    color: rgb(162, 162, 162);
}
</style>